
 <style>
 .cssTextarea {
    width:100%;
    height:calc(100vh - 224px);
  }
 
  </style>
<div class="container">

 
  <h2 class="content-heading"> 
    Edit Style Sheet
  </h2>
 
  <div class="cssEditorContainer" style="display: block" *ngIf="isLoading != true">
 
      <div class="cssTextarea" >  
        <ngx-codemirror  
        [(ngModel)]="css" [options]="{
          lineNumbers: true,
          theme: 'default',
          mode: 'css',
          lineWrapping: 'true', 
          styleActiveLine: {nonEmpty: true}
        }">
        </ngx-codemirror> 
      </div>

      <div  class="float-right">
        <button   (click)="cancel()" class="btn btn-sm btn-secondary" style="margin-right:10px">Cancel</button>
        <button  (click)="save()"   class="btn btn-sm btn-primary">Save</button> 
      </div>
 
  </div>
  
  <div class="keyNotes">

      <div>
        Ctrl-F / Cmd-F
        <div class="keyDescription">Start searching</div>
      </div>
      <div>
          Shift-Ctrl-F / Cmd-Option-F
        <div class="keyDescription">Replace</div>
      </div>
      <div>
          Shift-Ctrl-R / Shift-Cmd-Option-F
        <div class="keyDescription">Replace all</div>
      </div>  
  
    </div>
    

</div>

